// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/Images/Group-(1).png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/Images/confident-businessman-working-desk 1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  /* overflow-y: auto;
  overflow-x: hidden; */
}
.Contact p{
    font-size: 1.2rem;
    margin-bottom: 1rem;
}
.overlay{
    background-color: rgba(1, 45, 1, 0.815);
    overflow-y: auto;
}

.contactparagraph p{
    color: white;
    font-size: 1.4rem;
    width: 50%;
}
/* Get in Touch */
.Intouch{
    padding:2rem 6rem;
   
}
.Intouchsentence{
    margin-left: 10rem;
    margin-top: 4rem;
    width: 29%;
    
}
.location{
    width: 60%;
}
.location img {
    width: 60%;
}
table{
    /* padding: 1rem; */
    /* margin-right: 2rem; */
    font-size: 16px;
    font-weight: 200;
    border: 1px solid transparent;
}
td{
    margin-top: 2rem;
    padding: 2rem 1rem 1rem 0rem;
     border: 1px solid transparent;
     color: grey;
}
td:first-child{
    color: white;
}
.line::after{
    background:yellowgreen;
    width: 70%;
    height:.1rem ;
    left: 1%;
    border-radius: 1rem;
}
.locateUs p{
    color: white;
    font-size: 16px;
    width: 100%;
}
.locateUs p span{
    display: block;
}
/* LOCATION SECTION */

.address{
  width: 100vw;
  color: white;
  background-color: #013E01;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 110% 4%;

}
.addresscontainer{
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 1.4rem 1.4rem 1rem 5rem; */
}
.addresscontainer p{
  color: white;
  font-size: 1.4rem;
   margin-bottom: 2rem;
}
.box img{
  margin-right: 1rem;
}
.box h4{
  font-size:2rem;
  font-weight: 600;
}
.box p span{
  display: block;
  
}
.box{
  width: 414px;
}
.boxp{
  margin-left: 3rem;
}

.address_icons{
  width: 25px !important;
  height: 25px;
  object-fit: contain;
}
/* Forms */
.forms{
  background-color: rgb(1, 48, 1);
  width: 100%;
  height: 150vh;
  /* padding: 5rem; */
}
.formscontainer{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;

  background-position: 50% ;
  height: 100vh;
  width: 821px;
  position: relative;
  border-bottom-left-radius: 3rem;
  border-bottom-right-radius: 3rem;
  

}
.form{
  background: radial-gradient(circle at top, #eaad11a1, #5bbf14b3, #d40e1efa 80%);
  z-index: 999;
  padding: 4rem;
 
  width: 822px;
  height: 715px;
  margin-top: 39rem;
  border-radius: 3rem;

}
.firstname{
  display:flex ;
  width: 100%;
  justify-content: space-between;
  position: relative;
  align-items: flex-start;
}


textarea{
  outline: none;
  /* border: none; */
 width: 100%;
 padding: 1rem;
  border: 1px solid transparent;
  border-radius: 21px;
  margin-top: 1.4rem;
  margin-bottom: 1rem;
  /* margin-left: 2rem; */

}

.subject{
  /* margin: 2.5rem; */
  width: Hug (238px);
height: Hug (65px);

  
}
.btn{
width: 100%;
}

.inputcommon input {
  outline: none;
  /* border: none; */
  width: 338.77px;
  height: 51.59px;
  border: 1px solid transparent;
  border-radius: 21px;
  margin-top: 1.4rem;
  padding-left: 2rem;
  margin-bottom: 1rem;
}

.inputcommon input::placeholder{
  color: rgba(128, 128, 128, 0.442);
}


#Message{
height: 25vh;

}
label{
 
   color: white;
  font-size: 1.5rem;
  
}

textarea::placeholder{
  color: rgba(128, 128, 128, 0.242);
}

.formstart{
  position:absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
 
  background-color: #005b00b0;

  border: 1px solid transparent;
  border-bottom-left-radius: 3rem;
  border-bottom-right-radius: 3rem;
 
  box-shadow: var(--box-shadow);
  overflow: hidden;
}

/* Media screen */

@media screen and (max-width:1050px){
  .contact_map{
    width: 150% !important;
    height: 100%;
    object-fit: contain;
    
  }

  .Intouchsentence{
    margin-left: 0rem;
    
}
}

@media screen and (max-width:900px){
  .box h4{
    font-size:1.7rem;
  }
  .address{
    background-image: none;
  }

  .box{
    width: 320px;
  }

  .forms{
    height: 170vh;
  }

  .formscontainer,  .form{
    width: 650px;
  }

  .inputcommon input{
    width: 250px;
  }
  
  .contact_map{
    width: 150% !important;
    height: 100%;
    object-fit: contain;
    
  }

  .contact_locationmap_container{
    border: 1px solid red;
  }

  .Intouchsentence{
    margin-left: 0rem;
    
}
 
}

@media screen and (max-width:700px) {
    .contactparagraph p{
        width: 100%;
    }

    .contactus_p{
      padding-top: 30px;
    }
    .expertisecontainer{
        flex-direction: column;
      }
      .expertiseparagraph{
        width: 100%;
      }
      .expertiseparagraph h3 {
        width: 100%;
      }
      .location{
        flex-direction: column;
        align-items: center;
        width: 100%;
    
      }
      .products{
        margin-top: 0rem;
      }
      .overlay{
        display: inline;
        padding: 2rem 4rem;
        /* width: 100%; */
      }
      .Intouch{
        padding: 1rem;
      }
      .Intouchsentence{
        width: 100%;
        margin-left: 0rem;
      }
      .Intouchsentence h3{
        padding: 0;
        margin: 0;
        margin-bottom: 1.4rem;
        width: 100%;
      }

      .contact_map{
        width: 100% !important;
        height: 100%;
        object-fit: contain;
        
      }
      .line::after{
        display: none;
        margin-bottom: 1.4rem;
        
      }
      table{
        margin-top: 1.8rem;
        display:none;
      }
      .location{
        width: 100%;}
      
      .location img{
        width: 85%;
        margin-top: 1rem;
      }
      .locateUs p{ 
        display: none;
      }
      .address{
        background-image: none;
        background-position: none;
        background-color: none;
        padding: 30px 20px;
      }
      /* Location */
      .addresscontainer{
        flex-direction: column;
        padding: 1.4rem 1.4rem 1rem 1rem;
        justify-content: center;
      }

      .box{
        width: 100% !important ;
      }
      .box img{
        margin-right: 0rem;
        width: 4%;
      }
      .box{
        padding-bottom: 4rem;
      }
      .boxp{
        /* margin-left: 2rem; */
        padding-top: 10px;
      }
      .address_icons{
        width: 16px;
        height: 16px;
      }
      .formscontainer{
        display: flex;
        background-image: none;
        flex-wrap: wrap;
        width: 326px;
        margin: 1rem;
        height: 284px;
      }
      .formstart{
        display: none;
      }
     
      .firstname{
        flex-direction: column;
      }
      .inputcommon input{
        width:320px;
        height: 50px;

      }
      .btn{
        width: 100%;
      }

      #Message{
        /* margin-top: 2rem; */
        width:320px;
        height: 50px;
        
      }
      .subject{
        margin: 0rem;
        /* width: 47%; */
        width:320px;
        /* height: 65px; */

      }
      
      .form{
        width:  400px;
        margin-top: 15rem;
        border-radius: 3rem;
       
      
      }
      .forms{
        height: 130vh;
      }

      .location_map_svg{
        width: 450px;
        height: 400px;
      }
}
@media screen and (max-width:500px) {
  /* .formscontainer{
    display: flex;
    background-image: none;
    flex-wrap: wrap;
    width: 326px;
    margin: 1rem;
    height: 344px;
  } */

  .inputcommon input{
    width:300px;
  }

  #Message{
    width:300px;
  }
  .subject{
    width:300px;

  }

  .form{
    width:  380px;
    margin-top: 20rem;
    border-radius: 3rem;
    margin-left: 1rem;
  }

  .location_map_svg{
    width: 370px;
    height: 400px;
  }

}

@media screen and (max-width:400px){

  .inputcommon input{
    width:280px;
  }
  .btn{
    width: 100%;
  }
  #Message{
    width:280px;
  }
  .subject{
    width:280px;

  }

  .form{
    width:  350px;
    margin-top: 20rem;
    border-radius: 3rem;
  }

}

@media screen and (max-width:380px){

  .inputcommon input{
    width:230px;
  }

  #Message{
    width:230px;
  }
  .subject{
    width:230px;

  }

  .form{
    width:  310px;
    margin-top: 20rem;
    border-radius: 3rem;
    margin-left: 1.5rem;
  }
  .location_map_svg{
    width: 350px;
    height: 400px;
  }

}

@media screen and (max-width:330px){


  .formscontainer{
    display: flex;
    background-image: none;
    flex-wrap: wrap;
    width: 100%;
    /* margin: 1rem; */
    height: 284px;
  }

  .inputcommon input{
    width:200px;
  }
  .btn{
    width: 100%;
  }
  #Message{
    width:200px;
  }
  .subject{
    width:200px;
  }

  .form{
    width:  270px;
    margin-top: 20rem;
    border-radius: 3rem;
    margin-left: 0rem;
  }

  .location_map_svg{
    width: 300px;
    height: 400px;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT;uBACqB;AACvB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;AACA,iBAAiB;AACjB;IACI,iBAAiB;;AAErB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;;AAEd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,4BAA4B;KAC3B,6BAA6B;KAC7B,WAAW;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA,qBAAqB;;AAErB;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yDAAuD;EACvD,4BAA4B;EAC5B,4BAA4B;;AAE9B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,iBAAiB;GAChB,mBAAmB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;;AAEhB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA,UAAU;AACV;EACE,+BAA+B;EAC/B,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yDAAiF;EACjF,4BAA4B;EAC5B,sBAAsB;;EAEtB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;;;AAGlC;AACA;EACE,+EAA+E;EAC/E,YAAY;EACZ,aAAa;;EAEb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,kBAAkB;CACnB,WAAW;CACX,aAAa;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB,kBAAkB;;;AAGlB;AACA;AACA,WAAW;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;;AAGA;AACA,YAAY;;AAEZ;AACA;;GAEG,YAAY;EACb,iBAAiB;;AAEnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;;EAEV,2BAA2B;;EAE3B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;;EAEhC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;;EAErB;;EAEA;IACE,iBAAiB;;AAErB;AACA;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;;EAErB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;;AAErB;;AAEA;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;MACE,iBAAiB;IACnB;IACA;QACI,sBAAsB;MACxB;MACA;QACE,WAAW;MACb;MACA;QACE,WAAW;MACb;MACA;QACE,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;;MAEb;MACA;QACE,gBAAgB;MAClB;MACA;QACE,eAAe;QACf,kBAAkB;QAClB,iBAAiB;MACnB;MACA;QACE,aAAa;MACf;MACA;QACE,WAAW;QACX,iBAAiB;MACnB;MACA;QACE,UAAU;QACV,SAAS;QACT,qBAAqB;QACrB,WAAW;MACb;;MAEA;QACE,sBAAsB;QACtB,YAAY;QACZ,mBAAmB;;MAErB;MACA;QACE,aAAa;QACb,qBAAqB;;MAEvB;MACA;QACE,kBAAkB;QAClB,YAAY;MACd;MACA;QACE,WAAW,CAAC;;MAEd;QACE,UAAU;QACV,gBAAgB;MAClB;MACA;QACE,aAAa;MACf;MACA;QACE,sBAAsB;QACtB,yBAAyB;QACzB,sBAAsB;QACtB,kBAAkB;MACpB;MACA,aAAa;MACb;QACE,sBAAsB;QACtB,gCAAgC;QAChC,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;MACA;QACE,kBAAkB;QAClB,SAAS;MACX;MACA;QACE,oBAAoB;MACtB;MACA;QACE,uBAAuB;QACvB,iBAAiB;MACnB;MACA;QACE,WAAW;QACX,YAAY;MACd;MACA;QACE,aAAa;QACb,sBAAsB;QACtB,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,aAAa;MACf;MACA;QACE,aAAa;MACf;;MAEA;QACE,sBAAsB;MACxB;MACA;QACE,WAAW;QACX,YAAY;;MAEd;MACA;QACE,WAAW;MACb;;MAEA;QACE,sBAAsB;QACtB,WAAW;QACX,YAAY;;MAEd;MACA;QACE,YAAY;QACZ,gBAAgB;QAChB,WAAW;QACX,kBAAkB;;MAEpB;;MAEA;QACE,aAAa;QACb,iBAAiB;QACjB,mBAAmB;;;MAGrB;MACA;QACE,aAAa;MACf;;MAEA;QACE,YAAY;QACZ,aAAa;MACf;AACN;AACA;EACE;;;;;;;KAOG;;EAEH;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;;EAEb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;AAEF;;AAEA;;EAEE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;;EAEb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;AAEF;;AAEA;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;;EAEb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,aAAa;EACf;;AAEF;;AAEA;;;EAGE;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;AAEF","sourcesContent":["*{\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  /* overflow-y: auto;\n  overflow-x: hidden; */\n}\n.Contact p{\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n}\n.overlay{\n    background-color: rgba(1, 45, 1, 0.815);\n    overflow-y: auto;\n}\n\n.contactparagraph p{\n    color: white;\n    font-size: 1.4rem;\n    width: 50%;\n}\n/* Get in Touch */\n.Intouch{\n    padding:2rem 6rem;\n   \n}\n.Intouchsentence{\n    margin-left: 10rem;\n    margin-top: 4rem;\n    width: 29%;\n    \n}\n.location{\n    width: 60%;\n}\n.location img {\n    width: 60%;\n}\ntable{\n    /* padding: 1rem; */\n    /* margin-right: 2rem; */\n    font-size: 16px;\n    font-weight: 200;\n    border: 1px solid transparent;\n}\ntd{\n    margin-top: 2rem;\n    padding: 2rem 1rem 1rem 0rem;\n     border: 1px solid transparent;\n     color: grey;\n}\ntd:first-child{\n    color: white;\n}\n.line::after{\n    background:yellowgreen;\n    width: 70%;\n    height:.1rem ;\n    left: 1%;\n    border-radius: 1rem;\n}\n.locateUs p{\n    color: white;\n    font-size: 16px;\n    width: 100%;\n}\n.locateUs p span{\n    display: block;\n}\n/* LOCATION SECTION */\n\n.address{\n  width: 100vw;\n  color: white;\n  background-color: #013E01;\n  background-image: url(../Assets/Images/Group-\\(1\\).png);\n  background-repeat: no-repeat;\n  background-position: 110% 4%;\n\n}\n.addresscontainer{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* padding: 1.4rem 1.4rem 1rem 5rem; */\n}\n.addresscontainer p{\n  color: white;\n  font-size: 1.4rem;\n   margin-bottom: 2rem;\n}\n.box img{\n  margin-right: 1rem;\n}\n.box h4{\n  font-size:2rem;\n  font-weight: 600;\n}\n.box p span{\n  display: block;\n  \n}\n.box{\n  width: 414px;\n}\n.boxp{\n  margin-left: 3rem;\n}\n\n.address_icons{\n  width: 25px !important;\n  height: 25px;\n  object-fit: contain;\n}\n/* Forms */\n.forms{\n  background-color: rgb(1, 48, 1);\n  width: 100%;\n  height: 150vh;\n  /* padding: 5rem; */\n}\n.formscontainer{\n  background-image: url(../Assets/Images/confident-businessman-working-desk\\ 1.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  background-position: 50% ;\n  height: 100vh;\n  width: 821px;\n  position: relative;\n  border-bottom-left-radius: 3rem;\n  border-bottom-right-radius: 3rem;\n  \n\n}\n.form{\n  background: radial-gradient(circle at top, #eaad11a1, #5bbf14b3, #d40e1efa 80%);\n  z-index: 999;\n  padding: 4rem;\n \n  width: 822px;\n  height: 715px;\n  margin-top: 39rem;\n  border-radius: 3rem;\n\n}\n.firstname{\n  display:flex ;\n  width: 100%;\n  justify-content: space-between;\n  position: relative;\n  align-items: flex-start;\n}\n\n\ntextarea{\n  outline: none;\n  /* border: none; */\n width: 100%;\n padding: 1rem;\n  border: 1px solid transparent;\n  border-radius: 21px;\n  margin-top: 1.4rem;\n  margin-bottom: 1rem;\n  /* margin-left: 2rem; */\n\n}\n\n.subject{\n  /* margin: 2.5rem; */\n  width: Hug (238px);\nheight: Hug (65px);\n\n  \n}\n.btn{\nwidth: 100%;\n}\n\n.inputcommon input {\n  outline: none;\n  /* border: none; */\n  width: 338.77px;\n  height: 51.59px;\n  border: 1px solid transparent;\n  border-radius: 21px;\n  margin-top: 1.4rem;\n  padding-left: 2rem;\n  margin-bottom: 1rem;\n}\n\n.inputcommon input::placeholder{\n  color: rgba(128, 128, 128, 0.442);\n}\n\n\n#Message{\nheight: 25vh;\n\n}\nlabel{\n \n   color: white;\n  font-size: 1.5rem;\n  \n}\n\ntextarea::placeholder{\n  color: rgba(128, 128, 128, 0.242);\n}\n\n.formstart{\n  position:absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n \n  background-color: #005b00b0;\n\n  border: 1px solid transparent;\n  border-bottom-left-radius: 3rem;\n  border-bottom-right-radius: 3rem;\n \n  box-shadow: var(--box-shadow);\n  overflow: hidden;\n}\n\n/* Media screen */\n\n@media screen and (max-width:1050px){\n  .contact_map{\n    width: 150% !important;\n    height: 100%;\n    object-fit: contain;\n    \n  }\n\n  .Intouchsentence{\n    margin-left: 0rem;\n    \n}\n}\n\n@media screen and (max-width:900px){\n  .box h4{\n    font-size:1.7rem;\n  }\n  .address{\n    background-image: none;\n  }\n\n  .box{\n    width: 320px;\n  }\n\n  .forms{\n    height: 170vh;\n  }\n\n  .formscontainer,  .form{\n    width: 650px;\n  }\n\n  .inputcommon input{\n    width: 250px;\n  }\n  \n  .contact_map{\n    width: 150% !important;\n    height: 100%;\n    object-fit: contain;\n    \n  }\n\n  .contact_locationmap_container{\n    border: 1px solid red;\n  }\n\n  .Intouchsentence{\n    margin-left: 0rem;\n    \n}\n \n}\n\n@media screen and (max-width:700px) {\n    .contactparagraph p{\n        width: 100%;\n    }\n\n    .contactus_p{\n      padding-top: 30px;\n    }\n    .expertisecontainer{\n        flex-direction: column;\n      }\n      .expertiseparagraph{\n        width: 100%;\n      }\n      .expertiseparagraph h3 {\n        width: 100%;\n      }\n      .location{\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n    \n      }\n      .products{\n        margin-top: 0rem;\n      }\n      .overlay{\n        display: inline;\n        padding: 2rem 4rem;\n        /* width: 100%; */\n      }\n      .Intouch{\n        padding: 1rem;\n      }\n      .Intouchsentence{\n        width: 100%;\n        margin-left: 0rem;\n      }\n      .Intouchsentence h3{\n        padding: 0;\n        margin: 0;\n        margin-bottom: 1.4rem;\n        width: 100%;\n      }\n\n      .contact_map{\n        width: 100% !important;\n        height: 100%;\n        object-fit: contain;\n        \n      }\n      .line::after{\n        display: none;\n        margin-bottom: 1.4rem;\n        \n      }\n      table{\n        margin-top: 1.8rem;\n        display:none;\n      }\n      .location{\n        width: 100%;}\n      \n      .location img{\n        width: 85%;\n        margin-top: 1rem;\n      }\n      .locateUs p{ \n        display: none;\n      }\n      .address{\n        background-image: none;\n        background-position: none;\n        background-color: none;\n        padding: 30px 20px;\n      }\n      /* Location */\n      .addresscontainer{\n        flex-direction: column;\n        padding: 1.4rem 1.4rem 1rem 1rem;\n        justify-content: center;\n      }\n\n      .box{\n        width: 100% !important ;\n      }\n      .box img{\n        margin-right: 0rem;\n        width: 4%;\n      }\n      .box{\n        padding-bottom: 4rem;\n      }\n      .boxp{\n        /* margin-left: 2rem; */\n        padding-top: 10px;\n      }\n      .address_icons{\n        width: 16px;\n        height: 16px;\n      }\n      .formscontainer{\n        display: flex;\n        background-image: none;\n        flex-wrap: wrap;\n        width: 326px;\n        margin: 1rem;\n        height: 284px;\n      }\n      .formstart{\n        display: none;\n      }\n     \n      .firstname{\n        flex-direction: column;\n      }\n      .inputcommon input{\n        width:320px;\n        height: 50px;\n\n      }\n      .btn{\n        width: 100%;\n      }\n\n      #Message{\n        /* margin-top: 2rem; */\n        width:320px;\n        height: 50px;\n        \n      }\n      .subject{\n        margin: 0rem;\n        /* width: 47%; */\n        width:320px;\n        /* height: 65px; */\n\n      }\n      \n      .form{\n        width:  400px;\n        margin-top: 15rem;\n        border-radius: 3rem;\n       \n      \n      }\n      .forms{\n        height: 130vh;\n      }\n\n      .location_map_svg{\n        width: 450px;\n        height: 400px;\n      }\n}\n@media screen and (max-width:500px) {\n  /* .formscontainer{\n    display: flex;\n    background-image: none;\n    flex-wrap: wrap;\n    width: 326px;\n    margin: 1rem;\n    height: 344px;\n  } */\n\n  .inputcommon input{\n    width:300px;\n  }\n\n  #Message{\n    width:300px;\n  }\n  .subject{\n    width:300px;\n\n  }\n\n  .form{\n    width:  380px;\n    margin-top: 20rem;\n    border-radius: 3rem;\n    margin-left: 1rem;\n  }\n\n  .location_map_svg{\n    width: 370px;\n    height: 400px;\n  }\n\n}\n\n@media screen and (max-width:400px){\n\n  .inputcommon input{\n    width:280px;\n  }\n  .btn{\n    width: 100%;\n  }\n  #Message{\n    width:280px;\n  }\n  .subject{\n    width:280px;\n\n  }\n\n  .form{\n    width:  350px;\n    margin-top: 20rem;\n    border-radius: 3rem;\n  }\n\n}\n\n@media screen and (max-width:380px){\n\n  .inputcommon input{\n    width:230px;\n  }\n\n  #Message{\n    width:230px;\n  }\n  .subject{\n    width:230px;\n\n  }\n\n  .form{\n    width:  310px;\n    margin-top: 20rem;\n    border-radius: 3rem;\n    margin-left: 1.5rem;\n  }\n  .location_map_svg{\n    width: 350px;\n    height: 400px;\n  }\n\n}\n\n@media screen and (max-width:330px){\n\n\n  .formscontainer{\n    display: flex;\n    background-image: none;\n    flex-wrap: wrap;\n    width: 100%;\n    /* margin: 1rem; */\n    height: 284px;\n  }\n\n  .inputcommon input{\n    width:200px;\n  }\n  .btn{\n    width: 100%;\n  }\n  #Message{\n    width:200px;\n  }\n  .subject{\n    width:200px;\n  }\n\n  .form{\n    width:  270px;\n    margin-top: 20rem;\n    border-radius: 3rem;\n    margin-left: 0rem;\n  }\n\n  .location_map_svg{\n    width: 300px;\n    height: 400px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
